import { createTableSlice } from '../helpers';
import { TaskStatus } from '../../constants';

export const tableSlice = createTableSlice({
  name: 'labellerDashboard/pendingTable',
  url: '/api/labelTasks',
  filters: {
    status: TaskStatus.PENDING,
  },
});
